<template lang='pug'>
//- Side-Effect-Consult-Vendor
div(:class='$style[`cc-side-effect-consult-vendor`]')
  div(:class='$style[`cc-side-effect-consult-header`]')
    div(:class='$style[`cc-side-effect-consult-title`]')
      header.font-medium 選擇諮詢對象，開啟聊天室

  div(v-if='preloading' :class='$style[`cc-side-effect-consult-loading`]')
    IconLoading(:size='36' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-side-effect-consult-wrap`]')
    ul(v-if='consultRooms.length' :class='$style[`cc-side-effect-consult-room`]')
      li(v-for='items, index in consultRooms' :key='index' :class='$style[`cc-side-effect-consult-room-li`]')
        router-link(
          exact=true
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='`/sideeffect/consult?v=${items.team_id}&c=${items.read ? "yes" : "no"}`'
          @click.native='updateChatRemind(index)'
          :class='$style[`cc-side-effect-consult-room-btn`]')
          i(v-if='items.chat_remind' :class='$style[`cc-side-effect-consult-room-remind`]') 新
          div(:class='$style[`cc-side-effect-consult-room-main`]')
            figure(:class='$style[`cc-side-effect-consult-room-avatar`]')
              img(
                :src='avatarSrcLink(items.thumbSrc)'
                width='100%'
                height='100%')
            div(:class='$style[`cc-side-effect-consult-room-info`]')
              span.font-bold(:class='$style[`cc-side-effect-consult-room-info-title`]') {{ items.vendor }}
                i(v-if='items.service === `free`' :class='$style[`cc-side-effect-consult-room-level`]') 限時試用
              span.font-regular(:class='$style[`cc-side-effect-consult-room-info-subtitle`]') {{ items.intro }}
          div(:class='$style[`cc-side-effect-consult-room-panel`]')
            IconOpenArrow(:size='20' :color='`#98a1a1`')

    div(v-else :class='$style[`cc-side-effect-consult-start-trail`]')
      button.btn-extra(
        tabindex='0'
        aria-label='試用14天VIP會員'
        :class='$style[`cc-side-effect-consult-start-trail-btn`]'
        @click='handleStartFreeTrail')
        span.font-medium 試用14天VIP會員
      span(:class='$style[`cc-side-effect-consult-start-trail-tips`]') 試用結束後，可永久線上諮詢公益醫療顧問


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconOpenArrow from '../../icon/OpenArrow';
import IconLoading from '../../icon/Loading';
// import { mixin as clickaway } from 'vue-clickaway';
// import { debounce } from 'debounce';

import {
  putChatConsultRoomList,
} from '../../../js/restapi';

export default {
  components: {
    IconOpenArrow,
    IconLoading,
  },

  // props: {
  //   consultRooms: {
  //     type: Array,
  //     default: [],
  //   },
  // },

  created() {
    this.axiosLoadConsultRoomList();
  },

  data() {
    return {
      preloading: true,
      consultRooms: [],
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopFreeTrailStatus: 'global/POPFREETRAIL_STATUS',
    }),

    updateChatRemind(index) {
      this.consultRooms[index].chat_remind = false;
    },

    axiosLoadConsultRoomList() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const CONFIG = {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      };
      const USER_DATA = {
        auth_id: `${this.loginDjangoId}`
      };
      putChatConsultRoomList('', USER_DATA, CONFIG)
        .then((res) => {
          this.consultRooms = res.data;
          this.preloading = false;
          console.log('Load Consult Room');
        })
        .catch((err) => {
          this.preloading = false;
        })
    },

    handleStartFreeTrail() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        if (this.loginProfile.user_type === 'doctor') {
          this.changePopBoxStatus({
            active: true,
            include: 'warnNotDoctor',
          });
          return;
        }

        this.changePopFreeTrailStatus({
          active: true,
        });
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      authJwtToken: 'user/exportUserJwtToken',
      // subscribeVip: 'user/exportUserSubscribeVip',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectConsultVendor.scss';
</style>
